import { render, staticRenderFns } from "./testingRate.vue?vue&type=template&id=39784c37&scoped=true&"
import script from "./testingRate.vue?vue&type=script&lang=ts&"
export * from "./testingRate.vue?vue&type=script&lang=ts&"
import style0 from "./testingRate.vue?vue&type=style&index=0&id=39784c37&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39784c37",
  null
  
)

export default component.exports